module.exports = __webpack_public_path__ + "media/message-notification.77a01f17.mp3";